import styled from 'styled-components';

const ExtraContent = styled.div`
  margin-top: 4rem;

  h3 {
    margin-bottom: 2rem;
  }

  @media screen and (min-width: 481px) {
    p {
      font-size: 1.125rem;
      line-height: 1.625rem;
      margin-bottom: 1rem;
    }
  }
`;

export default ExtraContent;
